import type { DovetailInfo } from "../src/types";

export default {
    phone: "+44 7544 523423",
    email: "info@dovetailbars.co.uk",
} as DovetailInfo;
